/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { List, ListItem, withStyles } from "@material-ui/core";
import { Link } from "gatsby"

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";

import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

function SocialMediaLinks({ ...props }) {
  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <React.Fragment>
          <Button
            justIcon
            color="transparent"
            className={classes.margin5}
          >
            <a href="https://facebook.com/wetheshldrs" target="_blank" style={{color: "black"}}><FaFacebook/></a>
          </Button>
          <Button
            justIcon
            color="transparent"
            className={classes.margin5}
          >
            <a href="https://twitter.com/wetheshldrs" target="_blank" style={{color: "black"}}><FaTwitter/></a>
          </Button>
          <Button
            justIcon
            color="transparent"
            className={classes.margin5}
          >
            <a href="https://instagram.com/wetheshldrs" target="_blank" style={{color: "black"}}><FaInstagram/></a>
          </Button>
{/*          <Button
            justIcon
            color="transparent"
            className={classes.margin5}
          >
            <a target="_blank" style={{color: "black"}}><FaLinkedin/></a>
          </Button>*/}
      </React.Fragment>
  );
}

SocialMediaLinks.propTypes = {

};

export default withStyles(footerStyle)(SocialMediaLinks);
